import $ from 'jquery';
import BaseComponent from './baseComponent';

/**
 * Override stuff from the Drupal Webform / Drupal Form
 */
export default class DrupalForm extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);

    this.formIdentifier = options.formIdentifier || null;

    return this;
  }

  /**
     * Wrap the textarea-Addons like "word-count-info"
     *
     * @param $form
     */
  handleFormTextareaAddon($form) { // eslint-disable-line class-methods-use-this
    const textareas = $form.find('textarea');

    $.each(textareas, (index, textarea) => {
      const $textarea = $(textarea);
      const id = $textarea.attr('id');

      // Wrap counter with class for small font
      if ($(`#${id}_counter`).length > 0) {
        const $counter = $(`#${id}_counter`);
        const counterWrapper = '<div class="_font-size-small _margin-top-0.5 _margin-bottom-1 _color-blau"></div>';
        $counter.wrap(counterWrapper);
      }
    });
  }

  /**
     * Initialize function
     */
  init() {
    const $forms = $(this.formIdentifier);

    $.each($forms, (index, form) => {
      const $form = $(form);

      // handle textareas
      if ($form.find('textarea').length > 0) {
        this.handleFormTextareaAddon($form);
      }
    });
  }
}
